import React, { Component } from 'react';
import 'braft-editor/dist/index.css'
import './App.css';
import Header from './components/header';

class App extends Component {

  state = {
    editorState: null
  }

  handleEditorChange = (editorState) => {
    this.setState({ editorState })
  }
  render() {

    return (
      <div className="container">

        <Header />
      

      </div>

    )
  }
}

export default App;
